import Helpers from '../js/helpers';

export default new class Notification {
  constructor() {
    this.notificationItem = 'notification__item';
    this.notificationContainer = 'notification';
    this.animationSpeed = 1000;
    this.delayToRemoveError = 4000;

    // desktop
    this.desktopOptions = {
      right: '20px',
      opacity: 1,
    };

    // mobile
    this.mobileOptions = {
      top: '0px',
      opacity: 1,
    };
  }

  /**
     * Show error notification
     *
     * @param text
     */
  showError(text = null, isMessage) {
    if (!text) {
      return;
    }

    const timeStamp = new Date().getTime();
    let $notificationContainer = $(`.${this.notificationContainer}`);

    // add notification container
    if (!$notificationContainer.length) {
      $('body').append(`<div class="${this.notificationContainer}"></div>`);
      $notificationContainer = $(`.${this.notificationContainer}`);
    }

    // don't add notification if the same notification on the page
    const $notifications = $(`.${this.notificationItem}`);
    for (let i = 0; i < $notifications.length; i += 1) {
      if ($($notifications[i]).text().trim() === text.trim()) {
        return;
      }
    }

    // add notification item
    $notificationContainer.append(`<div data-time-stamp="${timeStamp}" class="${this.notificationItem}  ${isMessage ? '_message' : ''}">${text}</div>`);

    const $notificationItem = $(`.${this.notificationItem}`);

    // add notification item depends on the device type mobile/desktop
    if (Helpers.isMobile()) {
      this.options = this.mobileOptions;
    } else {
      this.options = this.desktopOptions;
    }

    // show notification on mobile
    $notificationItem.animate(this.options, this.animationSpeed, 'easeOutExpo');

    this.hideError($notificationItem);
  }

  /**
     * Hide and remove notification item from html
     *
     * @param $notificationItem - jquery obj of notification item
     * @param timeStamp - numeral timestamp for notification item to delete
     */
  hideError($notificationItem = null, timeStamp = null) {
    let itemToRemove = null;

    itemToRemove = $notificationItem || $(`[data-time-stamp="${timeStamp}"]`);

    // remove notification with delay
    setTimeout(() => {
      // hide by opacity
      itemToRemove.animate({
        opacity: 0,
      }, this.animationSpeed, 'easeOutExpo', () => {
        // remove notification from HTML
        itemToRemove.remove();
      });
    }, this.delayToRemoveError);
  }
}();
